export const defaultData = [...new Array(31).fill(1).map((x, i) => ({
    name: i + 1,
    ava: 0,
    sold: 0,
    occ: 0,
    adr: 0,
    revpar: 0,
    rev: 0,
    revper: 0,
    total: 0,
})), {
    name: "Grand total <br/>(ES2.1数据）",
    ava: 0,
    sold: 0,
    occ: 0,
    adr: 0,
    revpar: 0,
    rev: 0,
    revper: 0,
    total: 0,
}, {
    name: "Grand total<br/>(日报公式）",
    ava: 0,
    sold: 0,
    occ: 0,
    adr: 0,
    revpar: 0,
    rev: 0,
    revper: 0,
    total: 0,
}, {
    name: "Grand total<br/>(ES4.1数据）",
    ava: 0,
    sold: 0,
    occ: 0,
    adr: 0,
    revpar: 0,
    rev: 0,
    revper: 0,
    total: 0,
}]

export const columnsYear = [{
    title: 'Date',
    key: 'name',
    type: "text",
}, {
    title: 'Available room',
    key: 'ava',
}, {
    title: 'Sold Room',
    key: 'sold',
}, {
    title: 'Occupancy %',
    key: 'occ',
    type: "percent"
}, {
    title: 'ADR',
    key: 'adr',
}, {
    title: 'RevPAR',
    key: 'revpar',
}, {
    title: 'Room Revenue',
    key: 'rev',
}, {
    title: 'Room Revenue %',
    key: 'revper',
    type: "percent"
}, {
    title: 'Hotel Total Revenue',
    key: 'total',
}];


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2-daily/data.js